import { getWithoutPathPrefix } from './getWithoutPathPrefix';
import { segmentize } from './segmentize';

export const getInternalPath = (
  // path to the file, can be relative or absolute
  to: string,
  // the whole path to the current page
  pathname: string,
  // the name of the current page
  name: string,
): string => {
  if (to.match(/^(http|https|ftp|www)/g)) {
    return to;
  }

  let internalTo = to;

  if (to.startsWith('..')) {
    // number of levels we need to go up in the tree
    const segments = segmentize(to).filter(value => value === '..');
    const baseSegments = segmentize(pathname);
    // remove the page from the list
    if (name !== 'index') {
      baseSegments.pop();
    }
    // remove from the end based on the folder level
    const base = baseSegments
      .slice(0, baseSegments.length - segments.length)
      .join('/');

    const relative = segmentize(to).slice(segments.length).join('/');

    internalTo = `/${base}/${relative}/`;
  } else if (to.startsWith('.')) {
    const segments = segmentize(pathname);
    if (name !== 'index') {
      segments.pop();
    }
    const base = segments.join('/');

    const relative = segmentize(to).slice(1).join('/');

    internalTo = `/${base}/${relative}/`;
  } else if (to.startsWith('#') || to.startsWith('?')) {
    const segments = segmentize(pathname);
    if (name !== 'index') {
      segments.pop();
    }
    const base = segments.join('/');

    internalTo = `/${base}/${name}/${to}`;
  }

  return getWithoutPathPrefix(internalTo);
};
